<script setup>
const alertStore = useAlertMessageStore();
const showAlert = ref(false);

const alertContent = computed(() => alertStore.content);

watch(
  () => alertStore.visibility,
  () => {
    let timerShowMessage = null;

    if (alertStore.visibility) {
      showAlert.value = true;

      // show message and set timeout
      timerShowMessage = setTimeout(() => {
        alertStore.setVisibility(false);
        clearTimeout(timerShowMessage);
        timerShowMessage = null;
      }, 5000);

      return;
    }

    showAlert.value = false;
    timerShowMessage = null;
  },
  { immediate: true, deep: true }
);
</script>

<template>
  <div v-if="showAlert">
    <div :class="alertContent.type" class="messages">
      <div
        class="messages-content d-flex justify-content-center align-items-center"
      >
        <div
          class="messages__icon rounded-circle align-items-center d-inline-flex justify-content-center text-center"
        >
          <i
            v-if="alertContent.type === 'messages-success'"
            class="fa-solid fa-circle-check"
          />
          <i
            v-else-if="alertContent.type === 'messages-warning'"
            class="fa-solid fa-triangle-exclamation"
          />
          <i
            v-else-if="alertContent.type === 'messages-danger'"
            class="fa-solid fa-circle-exclamation"
          />
        </div>
        <div class="me-auto px-3">
          <h5 v-if="alertContent.title" class="mb-0">
            {{ alertContent.title }}
          </h5>
          <i18n-t
            v-if="alertContent.body"
            :keypath="alertContent.body"
            class="mb-0"
            tag="p"
          >
            <template #contact_support>
              {{ $t('contact.mail_support.description').toLowerCase() }}
              <a class="underline" href="mailto:support@salesupply.com">{{
                $t('contact.mail_support.technical_support')
              }}</a>
            </template>
          </i18n-t>
        </div>
      </div>
    </div>
  </div>
</template>
